<script>
	const { getFirstFocusableElement, getLastFocusableElement } = require('utilities');
	const Vue = require('vue');

	module.exports = {
		props: ['close', 'height'],

		data: function () {
			return {
				isOpen: false,
				topOffset: 0,
				tipTopOffset: 0,
				refocusTarget: null,
				label: ''
			};
		},

		methods: {
			show: function (target, label = '') {
				this.isOpen = true;
				this.focusFirstItem();
				this.refocusTarget = target;
				this.label = label;
			},
			hide: function () {
				this.isOpen = false;
				this.label = '';

				if (this.refocusTarget) {
					this.refocusTarget.focus();
				}

				if (typeof this.close === 'function') {
					this.close();
				}
			},
			focusFirstItem() {
				const popup = this.$refs.popupContent;
				const target = getFirstFocusableElement(popup) || popup;

				this.$nextTick(() => {
					target.focus();
				});
			},
			focusLastItem() {
				const popup = this.$refs.popupContent;
				const target = getLastFocusableElement(popup) || popup;

				this.$nextTick(() => {
					target.focus();
				});
			}
		},

		mounted() {
			Vue.nextTick(() => {
				const halfHeight = $('.popup', this.$el).outerHeight() / 2;

				this.topOffset = '-' + halfHeight + 'px';
				this.tipTopOffset = halfHeight - 10 + 'px';
			});
		}
	};
</script>
<template>
	<div
		class="popup-wrapper"
		@keydown.esc="hide"
		role="dialog"
		:aria-label="label">
		<div
			:style="{ height: height, top: topOffset }"
			:class="{ active: isOpen, popup: true }">
			<span
				class="tip"
				:style="{ top: tipTopOffset }"></span>
			<button
				class="focus-capture hidden-visually"
				aria-hidden="true"
				@focus="focusLastItem"></button>
			<div
				ref="popupContent"
				class="content-container"
				tabindex="-1">
				<button
					class="close button -link"
					aria-label="Close"
					v-on:click="hide">
					&times;
				</button>
				<slot name="content"></slot>
			</div>
			<button
				class="focus-capture hidden-visually"
				aria-hidden="true"
				@focus="focusFirstItem"></button>
		</div>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';

	.popup-wrapper {
		display: inline-block;
		position: relative;

		.popup {
			display: none;
			position: absolute;
			left: 15px;
			border-radius: 5px;
			box-shadow: 0 3px 3px rgba($c-black, 0.25);
			background-color: #f0f0f0;
			color: #000000;
			border: 1px solid $c-disabled-grey;
			cursor: default;
		}

		.popup .content-container {
			position: relative;
			height: 100%;
			width: 100%;
			padding: 0.75rem;
		}

		.popup .close {
			position: absolute;
			right: 0.25rem;
			top: 0;
			font-weight: 100;
			font-size: 1.75rem;
			cursor: pointer;
			z-index: 1;
			line-height: 1.25rem;
			color: $c-disabled-grey;
		}

		.popup .tip {
			position: absolute;
		}

		.popup .tip:after,
		.popup .tip:before {
			right: 100%;
			top: 50%;
			border: solid transparent;
			content: ' ';
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
		}

		.popup .tip:after {
			border-color: rgba(136, 183, 213, 0);
			border-right-color: #f0f0f0;
			border-width: 10px;
		}

		.popup .tip:before {
			border-color: rgba(0, 0, 0, 0);
			border-right-color: $c-disabled-grey;
			border-width: 12px;
			margin-top: -2px;
		}

		.popup.active {
			display: block;
		}
	}
</style>
